const menuArrow = document.querySelectorAll('.menu__link--button');

menuArrow.forEach((ele) => {
  const parent = ele.closest('.menu__item');

  if (windowWidth() < breakpointMd) {
    ele.addEventListener('click', () => {
      const openSubmenu = document.querySelector('.is-open-submenu');

      if (openSubmenu === parent) {
        parent.classList.remove('is-open-submenu');
        ele.setAttribute('aria-expanded', 'false');
        const dropdown = parent.querySelector('.menu__dropdown');
        if (dropdown) slideToggle(dropdown, 300, 'none');
        return;
      }

      if (openSubmenu && openSubmenu !== parent) {
        openSubmenu.classList.remove('is-open-submenu');
        openSubmenu.querySelector('button.menu__link')?.setAttribute('aria-expanded', 'false');
        const openDropdown = openSubmenu.querySelector('.menu__dropdown');
        if (openDropdown) slideToggle(openDropdown, 300, 'none');
      }

      parent.classList.add('is-open-submenu');
      ele.setAttribute('aria-expanded', 'true');
      const dropdown = parent.querySelector('.menu__dropdown');
      if (dropdown) slideToggle(dropdown, 300, 'block');
    });
  } else {
    parent.addEventListener('mouseenter', () => {
      if (!parent.classList.contains('is-submenu-open')) {
        parent.classList.add('is-open-submenu');
        ele.setAttribute('aria-expanded', 'true');
        document.body.classList.add('is-open-mega-menu');
      }
    });

    parent.addEventListener('mouseleave', () => {
      parent.classList.remove('is-open-submenu');
      ele.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('is-open-mega-menu');
    });

    ele.addEventListener('click', () => {
      const isOpen = parent.classList.toggle('is-open-submenu');
      ele.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.classList.toggle('is-open-mega-menu', isOpen);
    });

    ele.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        parent.classList.remove('is-open-submenu');
        ele.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('is-open-mega-menu');
        parent.querySelector('.menu__link')?.focus();
      }
    });

    parent.addEventListener('focusout', () => {
      setTimeout(() => {
        const focused = document.activeElement;
        if (!parent.contains(focused)) {
          parent.classList.remove('is-open-submenu');
          ele.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('is-open-mega-menu');
        }
      }, 100);
    });
  }
});

attachEvent('[data-close-menu]', 'click', (ev) => {
  document.body.classList.remove('is-open-mega-menu');
  const openSubmenu = document.querySelector('.is-open-submenu');
  openSubmenu?.querySelector('button.menu__link')?.setAttribute('aria-expanded', 'false');
  openSubmenu?.classList.remove('is-open-submenu');
  ev.preventDefault();
});
